import { Map as ImmutableMap } from 'immutable';
import { createSelector } from 'reselect';
import { SUCCEEDED } from '../constants/RequestStatusTypes';
export const getUsersMap = state => state.users.get('users');
export const getFetchUsersSucceeded = state => state.users.get('status') === SUCCEEDED;
export const getTeamsMap = state => state.teams.get('teams');
export const getTeamsStatus = state => state.teams.get('status');
export const getUsersNotOnTeams = state => {
  const teams = getTeamsMap(state);
  const usersOnTeams = teams.reduce((users, team) => users.merge(team.get('userIds').reduce((userMap, userId) => userMap.set(userId, true), ImmutableMap())), ImmutableMap());
  const allUsers = getUsersMap(state);
  const usersNotOnTeams = allUsers.keySeq().filter(userId => !usersOnTeams.get(userId));
  return usersNotOnTeams.toList();
};
export const getUsersToTeamsMap = createSelector([getTeamsMap], teams => teams.reduce((map, team) => map.merge(team.get('userIds').reduce((userMap, userId) => userMap.set(userId, team), ImmutableMap())), ImmutableMap()));
export const getUsersToTeamNameMap = createSelector([getTeamsMap], teams => teams.reduce((map, team) => map.merge(team.get('userIds').reduce((userMap, userId) => userMap.set(userId, team.get('name')), ImmutableMap())), ImmutableMap()));